import queryString from 'query-string';
import pickBy from 'lodash/pickBy';
export var imageBaseUrl = 'https://images.takeshape.io';
export var assetBaseUrl = 'https://assets.takeshape.io';
export function getPath(key) {
  return typeof key === 'object' ? 'path' in key ? key.path : key.s3Key : key;
}

function formatQuery(query) {
  if (query) {
    var filtered = pickBy(query, function (value) {
      return value !== '';
    });

    if (Object.keys(filtered).length) {
      return '?' + queryString.stringify(filtered);
    }
  }

  return '';
}

function escapePath(path) {
  return path.split('/').map(encodeURIComponent).join('/');
}

export function getAssetUrl(s3Key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = getPath(s3Key);
  var baseUrl = options.baseUrl || assetBaseUrl;
  return path ? "".concat(baseUrl, "/").concat(escapePath(path)) : '';
}
export function getImageUrl(key, query) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var path = getPath(key);
  var baseUrl = options.baseUrl || imageBaseUrl;
  return path ? "".concat(baseUrl, "/").concat(escapePath(path)).concat(formatQuery(query)) : '';
}